import { Box, Button } from "@mui/material";
import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import { ContentBlock } from "../../shared/sharedStyles";
import { RightSideInnerContent } from "./RightSideInnerContent";
import { DescriptionEditorContainer } from "./DescriptionEditorBlock";


export const RightSideBlock = ({
    handleImageButtonClick,
    lngsltd,
    handleVideoButtonClick,
    mediaInputRef,
    handleMediaUpload,
    removeMedia,
    handleVideoUpload,
    stepContentState,
    setStepContentState,
    selectedStep
}) => {
    return (
        <Box 
            display="flex" 
            flexDirection="column" 
            sx={{ 
                width: { xs: "100%", md: "70%" }, 
                height: { xs: "auto", md: "100%" },
                gap: { xs: 1.5, sm: 2 }
            }}
        >
            <ContentBlock 
                variant="outlined" 
                elevation={0} 
                sx={{ 
                    m: "0px !important", 
                    width: "100%", 
                    height: { xs: "auto", md: "auto" },
                    flex: { xs: "0 0 auto", md: "0 0 45%" },
                    minHeight: { xs: "400px", md: "300px" },
                    overflow: "auto",
                    borderRadius: '12px',
                    backgroundColor: '#ffffff',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                    p: { xs: 2, sm: 3 }
                }}
            >
                <Box 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="flex-start"
                    width="100%" 
                    mb={2.5}
                    sx={{
                        borderBottom: '1px solid #e9ecef',
                        pb: 1.5
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1.5,
                            backgroundColor: '#f8f9fa',
                            borderRadius: '6px',
                            p: 0.5
                        }}
                    >
                        <Button
                            onClick={handleImageButtonClick}
                            startIcon={<ImageIcon sx={{ fontSize: '1rem' }} />}
                            sx={{
                                minWidth: 'auto',
                                px: 2,
                                py: 0.75,
                                fontSize: '0.8125rem',
                                fontWeight: stepContentState.activeContentType === 'Image' ? 600 : 500,
                                textTransform: 'none',
                                borderRadius: '4px',
                                color: stepContentState.activeContentType === 'Image' ? '#ffffff' : '#6c757d',
                                backgroundColor: stepContentState.activeContentType === 'Image' ? '#dc3545' : 'transparent',
                                boxShadow: stepContentState.activeContentType === 'Image' ? '0 1px 3px rgba(220, 53, 69, 0.3)' : 'none',
                                '&:hover': {
                                    backgroundColor: stepContentState.activeContentType === 'Image' ? '#c82333' : 'rgba(220, 53, 69, 0.08)',
                                    color: stepContentState.activeContentType === 'Image' ? '#ffffff' : '#dc3545'
                                },
                                transition: 'all 0.2s ease'
                            }}
                        >
                            {lngsltd["Image"]}
                        </Button>
                        <Button
                            onClick={handleVideoButtonClick}
                            startIcon={<VideoLibraryIcon sx={{ fontSize: '1rem' }} />}
                            sx={{
                                minWidth: 'auto',
                                px: 2,
                                py: 0.75,
                                fontSize: '0.8125rem',
                                fontWeight: stepContentState.activeContentType === 'Video' ? 600 : 500,
                                textTransform: 'none',
                                borderRadius: '4px',
                                color: stepContentState.activeContentType === 'Video' ? '#ffffff' : '#6c757d',
                                backgroundColor: stepContentState.activeContentType === 'Video' ? '#dc3545' : 'transparent',
                                boxShadow: stepContentState.activeContentType === 'Video' ? '0 1px 3px rgba(220, 53, 69, 0.3)' : 'none',
                                '&:hover': {
                                    backgroundColor: stepContentState.activeContentType === 'Video' ? '#c82333' : 'rgba(220, 53, 69, 0.08)',
                                    color: stepContentState.activeContentType === 'Video' ? '#ffffff' : '#dc3545'
                                },
                                transition: 'all 0.2s ease'
                            }}
                        >
                            {lngsltd["Video"]}
                        </Button>
                    </Box>
                </Box>

                <RightSideInnerContent
                    mediaInputRef={mediaInputRef}
                    handleMediaUpload={handleMediaUpload}
                    removeMedia={removeMedia}
                    lngsltd={lngsltd}
                    handleVideoUpload={handleVideoUpload}
                    stepContentState={stepContentState}
                    setStepContentState={setStepContentState}
                />
            </ContentBlock>

            <DescriptionEditorContainer
                lngsltd={lngsltd}
                stepContentState={stepContentState}
                setStepContentState={setStepContentState}
                selectedStep={selectedStep}
            />
        </Box>
    );
};



